<template>
    <div class="wrapper">
        <h1 class="crumb">物流公司列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <el-button class="btn" @click="addWuliu">添加物流公司</el-button>

            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column label="物流公司名字" prop="name" align="center"></el-table-column>
            <!--<el-table-column label="联系电话" prop="leader_name" align="center" ></el-table-column>-->
            <el-table-column label="操作" align="center">
                <template slot-scope="props">
                    <a @click="Edit(props.row)">编辑</a><span> | </span><a @click="Delete(props.row.id)">删除</a>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        :page-size="10"
        layout=" total,prev, pager, next"
        :total="total">
        </el-pagination>
        <el-dialog :visible.sync="isAdd" :rules="rules"
                   title="添加物流公司">
            <el-form ref="forms" :rules="rules" :model="formData" style="padding: 30px" label-width="120px">
                <el-form-item label="物流公司名字：" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入物流公司名字"></el-input>
                </el-form-item>
                <!--<el-form-item label="送货司机电话：" prop="tel" >-->
                    <!--<el-input  placeholder="请输入送货司机电话" v-model="formData.tel"></el-input>-->
                <!--</el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isAdd = false, getDriverList()">取 消</el-button>
                <el-button type="primary" @click="Add">确 定</el-button>
            </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog :visible.sync="isEdit" :rules="rule"
                   title="编辑流公司">
            <el-form ref="form" :rules="rule" :model="editForm" style="padding: 30px" label-width="120px">
                <el-form-item label="物流公司名字：" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入物流公司名字"></el-input>
                </el-form-item>
                <!--<el-form-item label="送货司机电话：" prop="tel" >-->
                <!--<el-input  placeholder="请输入送货司机电话" v-model="formData.tel"></el-input>-->
                <!--</el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isAdd = false,getDriverList()">取 消</el-button>
                <el-button type="primary" @click="qrEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import qs from 'qs'
    export default {
        data() {
            return {
                tableData: [],
                page: 1,
                total: '',
                formData: {
                    name: '',
                    // tel: ''
                },
                editForm: '',
                isAdd: false,
                isEdit: false,
                rules: {
                    name: [{required: true, message: '请输入物流公司名字', trigger: 'blur'}]
                    // tel: [{required: true, message: '请输入司机电话', trigger: 'blur'}]
                },
                rule: {
                    name: [{required: true, message: '请输入物流公司名字', trigger: 'blur'}]
                    // tel: [{required: true, message: '请输入司机电话', trigger: 'blur'}]
                },
            }
        },
        created() {
            this.getDriverList()
        },
        methods: {
            getDriverList() {
                this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                    if (res.data.error === 0) {
                        this.tableData = res.data.data
                        this.total = res.data.count
                    }
                })
            },
            //添加公司
            addWuliu() {
                this.isAdd = true
            },
            //确认添加
            Add() {
                this.$refs.forms.validate(async (valid) => {
                    if (valid) {
                        this.$http.post(this.$reqUrl + `service.php?act=wuliu_update&session_id=${localStorage.getItem('shouhou_session_id')}&name=${this.formData.name}`).then(res => {
                            if (res.data.error === 0) {
                                this.$message.success(res.data.msg)
                                this.getDriverList()
                                this.isAdd = false
                            }
                        })
                    }
                })
            },
            Edit(row) {
                this.isEdit = true
                this.editForm = row
            },
            qrEdit() {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        this.$http.post(this.$reqUrl + `service.php?act=wuliu_update&session_id=${localStorage.getItem('shouhou_session_id')}&name=${this.editForm.name}&id=${this.editForm.id}`).then(res => {
                            if (res.data.error === 0) {
                                this.$message.success(res.data.msg)
                                this.getDriverList()
                                this.isEdit = false
                            }
                        })
                    }
                })
            },
            //删除
            Delete(id) {
                this.$alert('确认删除该物流公司?', '删除物流公司', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$http.get(this.$reqUrl + `service.php?act=wuliu_del&session_id=${localStorage.getItem('shouhou_session_id')}&id=${id}`).then(res => {
                            if (res.data.error === 0) {
                                this.$message.success(res.data.msg)
                                this.getDriverList()
                            }
                        })
                    }
                });
            },
            handleCurrentChange (val) {
                console.log(val)
                this.page = val
                this.getDriverList()
            },
        }
    }
</script>
<style lang="less">
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
        }
    }
</style>
<style>
    .el-table th>.cell{
        color:#ea6625;
    }
</style>



// WEBPACK FOOTER //
// src/router/WuliuList.vue